import {
    CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT,
    CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS,
    CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE,
    CREATE_CHALLENGE_PAGE_INIT,
    CREATE_CHALLENGE_PAGE_RESET,
    CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE,
    CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE,
    CREATE_CHALLENGE_PAGE_SET_STEP,
    CREATE_CHALLENGE_PAGE_SUBMIT,
    CREATE_CHALLENGE_PAGE_SUBMIT_DONE,
    CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION,
    CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE,
    CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE
} from './ActionTypes';

export const createChallengePageInit = ({ createFrom, initDisplayName, initGroupId }) => ({
    type: CREATE_CHALLENGE_PAGE_INIT,
    createFrom,
    initDisplayName,
    initGroupId
});

export const createChallengePageReset = () => ({
    type: CREATE_CHALLENGE_PAGE_RESET
});

export const createChallengePageSetStep = (step) => ({
    type: CREATE_CHALLENGE_PAGE_SET_STEP,
    step
});

export const createChallengePageSetChallengeType = ({ challengeType, challengeName }) => ({
    type: CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE,
    challengeType,
    challengeName
});

export const createChallengePageSetParticipantType = (participantType) => ({
    type: CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE,
    participantType
});

export const createChallengePageSetDurationType = ({ durationType, challengeDesc }) => ({
    type: CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE,
    durationType,
    challengeDesc
});

export const createChallengePageSetDurationStartDate = (startDate) => ({
    type: CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE,
    startDate
});

export const createChallengePageSetDurationEndDate = (endDate) => ({
    type: CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE,
    endDate
});

export const createChallengePageFetchParticipants = (isWheelchairMode) => ({
    type: CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS,
    isWheelchairMode
});

export const createChallengePageFetchParticipantsDone = ({
    error = false,
    wheelchairMode = false,
    initConnection = null,
    wheelchairConnections,
    nonWheelchairConnections,
    connections,
    groups
}) => ({
    type: CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE,
    error,
    wheelchairMode,
    initConnection,
    wheelchairConnections,
    nonWheelchairConnections,
    connections,
    groups
});

export const createChallengePageCheckParticipant = ({ displayName, groupId, checked }) => ({
    type: CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT,
    displayName,
    groupId,
    checked
});

export const createChallengePageSubmit = () => ({
    type: CREATE_CHALLENGE_PAGE_SUBMIT
});

export const createChallengePageSubmitDone = (error = false) => ({
    type: CREATE_CHALLENGE_PAGE_SUBMIT_DONE,
    error
});

export const createChallengePageCloseNotification = () => ({
    type: CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION
});

/**
 *
 * @param {{
 *  open: boolean;
 *  dialogType: number;
 *  commit: boolean?
 * }} payload
 * @returns
 */
export const createChallengePageSetSummaryDialogState = ({ open, dialogType, commit }) => ({
    type: CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE,
    open,
    dialogType,
    commit
});

export const createChallengePageSetDiscardDialogState = ({ open }) => ({
    type: CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE,
    open
});
